var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { supportedWallets } from '@lifi/wallet-management';
import { Avatar, Button, Container, DialogActions, DialogContent, DialogContentText, List, ListItemAvatar, } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../../components/Dialog';
import { useNavigateBack } from '../../hooks';
import { useWallet } from '../../providers';
import { ListItemButton, ListItemText } from './SelectWalletPage.style';
export const SelectWalletPage = () => {
    var _a;
    const { t } = useTranslation();
    const { navigateBack } = useNavigateBack();
    const { connect } = useWallet();
    const [walletIdentity, setWalletIdentity] = useState({ show: false });
    const closeDialog = () => {
        setWalletIdentity((state) => (Object.assign(Object.assign({}, state), { show: false })));
    };
    const handleConnect = useCallback((wallet) => __awaiter(void 0, void 0, void 0, function* () {
        const { ethereum } = window;
        const identityCheckPassed = wallet.checkProviderIdentity({
            provider: ethereum,
        });
        if (!identityCheckPassed) {
            setWalletIdentity({
                show: true,
                wallet,
            });
            return;
        }
        navigateBack();
        yield connect(wallet);
    }), [connect, navigateBack]);
    return (_jsxs(Container, Object.assign({ disableGutters: true }, { children: [_jsx(List, Object.assign({ sx: {
                    paddingLeft: 1.5,
                    paddingRight: 1.5,
                } }, { children: supportedWallets.map((wallet) => (_jsxs(ListItemButton, Object.assign({ onClick: () => handleConnect(wallet), disableRipple: true }, { children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, Object.assign({ src: wallet.icon.src || wallet.icon, alt: wallet.name }, { children: wallet.name[0] })) }), _jsx(ListItemText, { primary: wallet.name })] }), wallet.name))) })), _jsxs(Dialog, Object.assign({ open: walletIdentity.show, onClose: closeDialog }, { children: [_jsx(DialogContent, { children: _jsx(DialogContentText, { children: t('wallet.extensionNotFound', {
                                name: (_a = walletIdentity.wallet) === null || _a === void 0 ? void 0 : _a.name,
                            }) }) }), _jsx(DialogActions, { children: _jsx(Button, Object.assign({ variant: "contained", onClick: closeDialog, autoFocus: true }, { children: t('button.ok') })) })] }))] })));
};
